import { SideBarDef, ToolPanelDef } from 'ag-grid-community';
import { TreeDataConfig } from '../interfaces/grid-context';
import { GridOptions } from '../interfaces/grid-options';

export default class GridUtils {
  /** Appends `toolPanel` to `gridOptions.sideBar.toolPanels` only if a panel
   *  with the same `id` is not already present. When `iconHtml` is provided
   *  and the panel declares an `iconKey`, the HTML is registered on
   *  `gridOptions.icons` so AG Grid renders it instead of the default
   *  placeholder. No-op when `sideBar` is not a `SideBarDef` object. */
  static addToolPanelIfMissing(
    gridOptions: GridOptions | undefined,
    toolPanel: ToolPanelDef,
    iconHtml?: string
  ): void {
    const sideBar = gridOptions?.sideBar as SideBarDef | undefined;
    if (!sideBar?.toolPanels) return;
    const toolPanels = sideBar.toolPanels as Array<ToolPanelDef | string>;
    if (toolPanels.some(p => typeof p === 'object' && p.id === toolPanel.id)) {
      return;
    }
    toolPanels.push(toolPanel);
    if (iconHtml && toolPanel.iconKey && gridOptions) {
      gridOptions.icons = {
        ...gridOptions.icons,
        [toolPanel.iconKey]: iconHtml,
      };
    }
  }

  /** Sets the `treePath` property on each item in the array */
  static getDataWithTreePath = <TData = object>(
    data: TData[],
    treeDataConfig: TreeDataConfig
  ): (TData & { treePath: string[] })[] => {
    const getParentPath = (parentId: number | null): string[] => {
      const parentItem = data.find(
        item => parentId && item[treeDataConfig.idField] === parentId
      );
      return parentItem
        ? getParentPath(parentItem[treeDataConfig.parentField]).concat(
            parentItem[treeDataConfig.idField]
          )
        : [];
    };

    return data.map(item => ({
      ...item,
      treePath: getParentPath(item[treeDataConfig.parentField]).concat(
        item[treeDataConfig.idField]
      ),
    }));
  };
}
